module.exports = __webpack_public_path__ + "static/award5-fc75ab5554798e95acc475b6dca2cd4b.png";